import type { ComponentNameAndModule } from '@sitecore-jss/sitecore-jss-angular';

const loadChildren = () =>
  import('./lib/solar-panels.lazy.module').then(
    (module) => module.SolarPanelsLazyModule
  );

const defineImport = (path: string) => ({
  path,
  loadChildren,
});

const solarPanelsLazyImports: ComponentNameAndModule[] = [
  defineImport('SolarPanelsSuitabilityCheck'),
  defineImport('SolarPanelsProductOverview'),
  defineImport('SolarPanelsOrderForm'),
  defineImport('SolarPanelsReceipt'),
  defineImport('SolarPanelsResultOverview'),
  defineImport('SolarPanelsResultOverviewSummary'),
];

export { solarPanelsLazyImports };
